import React from 'react';

const CURRENT_YEAR = new Date().getFullYear();

const Support = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-indigo-50 via-white to-indigo-100 px-4 py-10">
      <div className="mx-auto max-w-4xl">
        <section className="rounded-2xl border border-indigo-100 bg-white p-6 shadow-lg md:p-8">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-indigo-500">Kidung Jemaat</p>
          <h1 className="mt-2 text-3xl font-black text-indigo-900 md:text-4xl">Support</h1>
          <p className="mt-4 leading-relaxed text-slate-700">
            This page is the official support page for Kidung Jemaat. If you have account, bug, purchase, or general questions, please contact support using the details below.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href="mailto:dimas.nath@icloud.com?subject=Kidung%20Jemaat%20Support%20Request"
              className="inline-flex items-center justify-center rounded-full bg-indigo-700 px-5 py-2 text-sm font-semibold text-white transition hover:bg-indigo-800"
            >
              Email Support
            </a>
            <a
              href="/"
              className="inline-flex items-center justify-center rounded-full border border-indigo-200 bg-white px-5 py-2 text-sm font-semibold text-indigo-700 transition hover:bg-indigo-50"
            >
              Back to Home
            </a>
          </div>
        </section>

        <section className="mt-5 rounded-2xl border border-indigo-100 bg-white p-6 shadow-sm">
          <h2 className="text-xl font-bold text-indigo-900">Contact</h2>
          <ul className="mt-3 list-disc space-y-1 pl-5 leading-relaxed text-slate-700">
            <li>Email: <a className="text-indigo-700 underline" href="mailto:dimas.nath@icloud.com">dimas.nath@icloud.com</a></li>
            <li>Estimated response time: 1-3 business days</li>
            <li>Support languages: Indonesian and English</li>
          </ul>
        </section>

        <section className="mt-5 rounded-2xl border border-indigo-100 bg-white p-6 shadow-sm">
          <h2 className="text-xl font-bold text-indigo-900">Before Contacting Support</h2>
          <ol className="mt-3 list-decimal space-y-1 pl-5 leading-relaxed text-slate-700">
            <li>Make sure the app is updated to the latest version.</li>
            <li>Close and reopen the app.</li>
            <li>Restart your device if the app is not responding.</li>
            <li>If the issue persists, send your device info, OS version, and an error screenshot.</li>
          </ol>
        </section>

        <section className="mt-5 rounded-2xl border border-indigo-100 bg-white p-6 shadow-sm">
          <h2 className="text-xl font-bold text-indigo-900">FAQ</h2>
          <div className="mt-3 space-y-4 leading-relaxed text-slate-700">
            <div>
              <h3 className="font-semibold text-slate-900">What if the app cannot be opened?</h3>
              <p>Update to the latest version, restart your device, then try again.</p>
            </div>
            <div>
              <h3 className="font-semibold text-slate-900">How do I report a bug?</h3>
              <p>Send support an email with reproduction steps, screenshots, and device model.</p>
            </div>
            <div>
              <h3 className="font-semibold text-slate-900">Where can I read the privacy policy?</h3>
              <p>See the <a className="text-indigo-700 underline" href="/privacy-policy">Privacy Policy</a> page.</p>
            </div>
          </div>
        </section>

        <p className="mt-6 text-center text-sm text-indigo-500">&copy; Kidung Jemaat App {CURRENT_YEAR}</p>
      </div>
    </div>
  );
};

export default Support;
